module.exports = __webpack_public_path__ + "static/media/arrow-right.ddc02a84.svg";